var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var plugin = require('tailwindcss/plugin');

var lineClamp = plugin(function (_ref) {
  var addUtilities = _ref.addUtilities,
      theme = _ref.theme,
      variants = _ref.variants,
      e = _ref.e;
  var values = theme('lineClamp');
  addUtilities([Object.entries(values).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return _defineProperty({}, ".".concat(e("line-clamp-".concat(key))), {
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': "".concat(value)
    });
  }), {
    '.line-clamp-none': {
      '-webkit-line-clamp': 'unset'
    }
  }], variants('lineClamp'));
}, {
  theme: {
    lineClamp: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6'
    }
  },
  variants: {
    lineClamp: ['responsive']
  }
});
module.exports = lineClamp;